import React, { useState, useEffect } from 'react';
import moment from 'moment';
import { Box } from '@material-ui/core';
import styles from './RenderWeeks.style';

function RenderWeeks({
	_month,
	cbWeekHighlight,
	calSelection,
	showWkSelection,
	showWalCal,
	minWk,
	maxWk
}) {
	const [wmWeeks, setWmWeeks] = useState([]);
	const [actualWeeks, setActualWeeks] = useState([]);
	const classes = styles();
	const {
		flexCol,
		dayHeader,
		block,
		dayBg,
		weekBgBorderStart,
		weekBgBorderEnd,
		range,
		daySelected,
		dayTransparent,
		dftCursor,
		disabled,
		pointerCursor
	} = classes;

	const yearL = 'year';
	const monthL = 'month';
	const weekL = 'week';
	useEffect(() => {
		if (showWalCal) {
			getWeekNo(_month);
		} else {
			printActualWeek(_month);
		}
	}, [_month]);

	function getWeekNo(monthIdx) {
		const currMonth = moment().clone().set(monthL, monthIdx);
		const currentMonthIdx = currMonth.month();
		const currYear = currMonth.year();
		const prevYear = currYear - 1;
		const appliedYear = currentMonthIdx === 0 ? prevYear : currYear;
		const lastDayIndex = moment()
			.set(monthL, currentMonthIdx)
			.set(yearL, currYear)
			.endOf(monthL)
			.day();

		let prevYearEndWkNo = moment().clone().set(yearL, prevYear).endOf(yearL).week();

		let currYearStartWekNo = moment().clone().set(yearL, currYear).startOf(yearL).week();

		let currYrFebMonthStartWk = moment()
			.clone()
			.set(yearL, appliedYear)
			.set('date', 1)
			.set(monthL, 1)
			.week();

		const o = [];

		let offset = prevYearEndWkNo >= currYearStartWekNo ? 1 : 0;
		let startWkNo = currMonth.clone().startOf(monthL).startOf(weekL);
		const lastWkNo = currMonth.clone().endOf(monthL).endOf(weekL);
		while (lastWkNo.isSameOrAfter(startWkNo)) {
			let val = startWkNo.week() - currYrFebMonthStartWk + offset;

			if (currentMonthIdx === 0) {
				val = prevYearEndWkNo - currYrFebMonthStartWk + offset;
				if (startWkNo.week() < 52) {
					val += startWkNo.week();
				}
				if (val > 52 && lastDayIndex !== 5) {
					val = 1;
				}
			}
			o.push({ wkNo: val, dates: startWkNo });
			startWkNo = startWkNo.clone().add(1, weekL);
		}
		setWmWeeks(o);
	}

	function printActualWeek(pMonth) {
		const currMonth = moment().set(monthL, pMonth);
		const currYear = currMonth.year();

		const _moment = moment().clone().set(monthL, pMonth).set(yearL, currYear);

		let startWeek = _moment.clone().startOf(monthL).startOf(weekL);
		const endWeek = _moment.clone().endOf(monthL).endOf(weekL);

		const weeks = [];
		while (startWeek.isSameOrBefore(endWeek, weekL)) {
			weeks.push(startWeek);
			startWeek = startWeek.clone().add(1, weekL);
		}

		setActualWeeks(weeks);
	}

	function addWeekStyles(pWeek) {
		if (pWeek.isBefore(minWk, weekL) || pWeek.isAfter(maxWk, weekL) || !showWkSelection) {
			return `${block} ${disabled} ${dftCursor}`;
		}

		if (showWkSelection) {
			const { start, end } = calSelection;

			if (![start, end].includes(undefined)) {
				if (pWeek.isSame(start, 'day') || pWeek.isSame(end, 'day')) {
					return `${block} ${range}`;
				}

				/** Hightlight the week number vertically */
				if (pWeek.isSameOrAfter(start, 'day') && pWeek.isSameOrBefore(end, 'day')) {
					return `${block} ${daySelected}`;
				}
			}
		}
		return block;
	}

	function handleWeekSelection(actualWk, wk) {
		if (!showWkSelection) {
			return;
		}

		if (actualWk.isSameOrAfter(minWk, weekL) && actualWk.isSameOrBefore(maxWk, weekL)) {
			cbWeekHighlight(actualWk, wk);
		}
	}

	function addWkBgStyle(pWeek) {
		if (showWkSelection) {
			const { start, end } = calSelection;
			if (![start, end].includes(undefined)) {
				if (pWeek.startOf(weekL).isSame(start)) {
					return `${dayBg} ${weekBgBorderStart} ${pointerCursor}`;
				}
				if (pWeek.endOf(weekL).isSame(end)) {
					return `${dayBg} ${weekBgBorderEnd} ${pointerCursor}`;
				}
			}
		}
		return `${dayTransparent} ${pointerCursor}`;
	}

	if (!showWalCal) {
		return (
			<Box className={flexCol}>
				<Box className={dayHeader}>WK</Box>
				{actualWeeks.map((wk, index) => {
					return (
						<Box className={addWkBgStyle(actualWeeks[index])} key={wk.week()}>
							<Box
								role="button"
								className={addWeekStyles(actualWeeks[index])}
								onClick={() => handleWeekSelection(actualWeeks[index], wk.week())}>
								{wk.week()}
							</Box>
						</Box>
					);
				})}
			</Box>
		);
	}

	return (
		<Box className={flexCol}>
			<Box className={dayHeader}>WK</Box>
			{wmWeeks.map((item) => {
				return (
					<Box className={addWkBgStyle(item.dates)} key={crypto.randomUUID()}>
						<Box
							role="button"
							id={`week-${item.wkNo}`}
							className={addWeekStyles(item.dates)}
							onClick={() => handleWeekSelection(item.dates, item.wkNo)}>
							{item.wkNo}
						</Box>
					</Box>
				);
			})}
		</Box>
	);
}

export default RenderWeeks;
